"use strict";

function initCarousel() {
  if ($('.js-carousel').length) {
    $('.js-carousel').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      dots: true,
      arrows: true,
      pauseOnHover: false,
      prevArrow: '<a class="slick-prev"><i class="icon icon-arrow-left"></i></a>',
      nextArrow: '<a class="slick-next"><i class="icon icon-arrow-right"></i></a>',
      responsive: [{
        breakpoint: 1100,
        settings: {
          arrows: false
        }
      }]
    });
    $('.js-carousel').on('breakpoint', function () {
      $(this).find('.js-async-bg').addClass('not-loaded');
      asyncBg();
    });
  }

  $(".js-carousel-nav .item").click(function (e) {
    e.preventDefault();
    $('.js-carousel-nav .item').removeClass('active');
    $(this).addClass('active');
    var slideIndex = $(this).index();
    $('.js-carousel').slick('slickGoTo', parseInt(slideIndex));
  });

  if ($('.js-carousel-fade').length) {
    $('.js-carousel-fade').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      fade: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      dots: false,
      arrows: false,
      pauseOnHover: true
    });
  }

  if ($('.js-carousel-simulator').length) {
    $('.js-carousel-simulator').slick({
      infinite: true,
      // autoplay: true,
      // autoplaySpeed: 4000,
      speed: 1000,
      centerMode: true,
      centerPadding: '96px',
      // focusOnSelect: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerPadding: '200px'
        }
      }, {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px'
        }
      }]
    });
  }
} // function setSlideVisibility() {
//   //Find the visible slides i.e. where aria-hidden="false"
//   var visibleSlides = $('.slick-slide[aria-hidden="false"]');
//   //Make sure all of the visible slides have an opacity of 1
//   $(visibleSlides).each(function() {
//     $(this).css('opacity', 1);
//   });
//   //Set the opacity of the first and last partial slides.
//   $(visibleSlides).first().prev().css('opacity', 0);
//   $(visibleSlides).last().next().css('opacity', 0);
// }
// $(setSlideVisibility());
// $('.js-carousel-simulator').on('beforeChange', function() {
//   $('.slick-slide').each(function() {
//     $(this).css('opacity', 1);
//   });
// });
// $('.js-carousel-simulator').on('afterChange', function() {
//   setSlideVisibility();
// });